import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { TermsLink } from '@startuptools/ui/links/Terms';
import { MenuItem } from '@startuptools/ui/MenuItem';
import { ListItemDecorator } from '@startuptools/ui/ListItemDecorator';

export const TermsMenuItem = () => {
  return (
    <MenuItem>
      <ListItemDecorator>
        <OpenInNewIcon />
      </ListItemDecorator>
      <TermsLink underline="none" color="neutral" rel="noreferrer" />
    </MenuItem>
  );
};
